const sources = {
  home: {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  },
  vacancy: {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  },
  vacancies: {
    type: 'geojson',
    promoteId: 'OIDN',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
    cluster: true,
    clusterMaxZoom: 18,
    clusterRadius: 35,
    clusterProperties: {
      clusterFeatureIds: ['concat', ['get', 'vacancyStringForCluserLogic']],
      sum: ['+', ['get', 'vacanciesCount']],
    },
  },
  'search-geometry': {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  },
  fietssnelwegen: {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
    promoteId: 'FSW_NUMMER',
  },
  'nearby-stops': {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  },
  'hovered-nearby-stop': {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  },
  'vacancy-route': {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  },
}

export default sources;